import { SortCriteria } from '../models'

export function sort<T>(data: T[], criteria: SortCriteria<T>): T[] {
  return data.slice().sort((a, b) => {
    for (const key in criteria) {
      if (Object.prototype.hasOwnProperty.call(criteria, key)) {
        const order = criteria[key as keyof T]
        if (order === 'asc' || order === 'desc') {
          const valueA = a[key as keyof T]
          const valueB = b[key as keyof T]

          if (!valueA && !valueB) {
            continue
          }
          if (!valueA) {
            return order === 'asc' ? -1 : 1
          }
          if (!valueB) {
            return order === 'asc' ? 1 : -1
          }

          if (valueA < valueB) {
            return order === 'asc' ? -1 : 1
          }
          if (valueA > valueB) {
            return order === 'asc' ? 1 : -1
          }
        }
      }
    }
    return 0
  })
}
